import { Component, DestroyRef, inject, Input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggingService, STREAMAMG_CONFIG, StreamAMGService } from '@fgb/core';

@Component({
  selector: 'fgbcl-stream-amg-player',
  standalone: true,
  imports: [],
  templateUrl: './stream-amg-player.component.html',
  styleUrl: './stream-amg-player.component.scss',
})
export class StreamAMGPlayerComponent implements OnInit {
  @Input() streamKey: string;
  playerId = `stream-player-${crypto.randomUUID()}`;
  hasError = signal(false);
  protected readonly streamService = inject(StreamAMGService);
  protected readonly loggingService = inject(LoggingService);
  protected readonly streamAmgConfig = inject(STREAMAMG_CONFIG);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.streamService
      .loadJs()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.initializePlayer();
        },
        error: () => {},
      });
  }

  private initializePlayer() {
    const playback = (window as any).Playback;

    if (!playback) {
      this.loggingService.error('StreamAMG SDK not available');
      this.hasError.set(true);
      return;
    }

    if (!this.streamAmgConfig) {
      this.loggingService.debug('Unable to get config');
      this.hasError.set(true);
      return;
    }

    playback.initialize(this.streamAmgConfig.ApiKey);

    playback
      .play({
        container: this.playerId,
        entryId: this.streamKey,
      })
      .catch(() => this.hasError.set(true));
  }
}
